import $ from 'jquery';
window.$ = window.jQuery = $;

require('./bootstrap');

import 'datatables';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-responsive';

import '@fortawesome/fontawesome-free/js/all.js';

require('select2');

window.swal = require('sweetalert2');

import './global-datatables';